
import { ref } from 'vue';
import useFirebaseChat from "@/compositions/firebase";

export default {
  setup(){
    const { sendMessage, getMessages, getEnable } = useFirebaseChat();

    const name = ref<string>("")
    const chatMessage = ref<string>("")

    const chat = () => {
      sendMessage(`[${ name.value }]: ${chatMessage.value}`)
      chatMessage.value = ""
    }

    return {
      name,
      chatMessage,
      chat,
      messages:getMessages,
      enabled: getEnable
    }
  }
}
